
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type collapsibleVerifyFitmentRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function collapsibleVerifyFitmentRT(): TemplateResult<collapsibleVerifyFitmentRTRootProps> {
    function repeatSelects1(selects, selectsIndex) {
        return [selects(function () {
                function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                }
                function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                }
                function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                    var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                    var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                    var isPopularField = popularEntries.length && unpopularEntries.length;
                    return [
                        !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                            'value': '',
                            'key': 'null-option'
                        }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                        this.loading ? _createElement('option', {
                            'key': 'loading-option',
                            'disabled': true
                        }, _translate(`select_loading`)) : null,
                        isPopularField ? [
                            _createElement('option', {
                                'className': 'cm_option_title cm_option-popular',
                                'disabled': true,
                                'key': '11021'
                            }, _translate(`ymm_bar_popular`)),
                            _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                            _createElement('option', {
                                'className': 'cm_option_title cm_option-unpopular',
                                'disabled': true,
                                'key': '11024'
                            }, _translate(`ymm_bar_unpopular`))
                        ] : null,
                        _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                    ];
                }
                function scopeShowSelectedValues4() {
                    var showSelectedValues = this.selectedEntries.length;
                    return _createElement('option', {
                        'key': '_current',
                        'value': '_current'
                    }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                        _translate(`select_title`),
                        ' ',
                        this.title
                    ] : null);
                }
                function repeatEntry5(entry, index) {
                    return _createElement('div', {
                        'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                        'key': entry.value,
                        'onClick': () => this.onChange(entry.term)
                    }, this.showCheckboxes ? _createElement('input', {
                        'type': 'checkbox',
                        'readOnly': true,
                        'checked': entry.selected,
                        'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                        'key': '3324'
                    }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                        'className': 'cm_dropdown_hitCount',
                        'key': '3526'
                    }, entry.hitCount) : null);
                }
                return _createElement('div', { 'className': this.extraClassName }, !this.isSearchable ? _createElement('div', {
                    'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                    'key': '39'
                }, _createElement('select', {
                    'className': 'cm_select_inner-select cm_select__pretty',
                    'onChange': this.onChange,
                    'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                    'disabled': this.disabled,
                    'aria-label': this.title
                }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                            return _createElement('div', { 'className': 'cm_filterInput' });
                        }, {
                            widgetName: 'undefined',
                            items: undefined
                        })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                    'div',
                    {
                        'className': 'cm_dropdown cm_select_dropdown cm_hide',
                        'aria-label': this.title,
                        'key': '2586'
                    },
                    !this.hideNullOption ? _createElement('div', {
                        'className': 'option',
                        'key': 'null-option',
                        'onClick': () => this.onChange('')
                    }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                    this.loading ? _createElement('div', {
                        'className': 'option',
                        'key': 'null-option',
                        'disabled': true
                    }, _translate(`select_loading`)) : null,
                    !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                ]) : null);
            }, { count: undefined })];
    }
    function repeatSelects2(selects, selectsIndex) {
        return [selects(function () {
                function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                }
                function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                }
                function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                    var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                    var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                    var isPopularField = popularEntries.length && unpopularEntries.length;
                    return [
                        !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                            'value': '',
                            'key': 'null-option'
                        }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                        this.loading ? _createElement('option', {
                            'key': 'loading-option',
                            'disabled': true
                        }, _translate(`select_loading`)) : null,
                        isPopularField ? [
                            _createElement('option', {
                                'className': 'cm_option_title cm_option-popular',
                                'disabled': true,
                                'key': '11021'
                            }, _translate(`ymm_bar_popular`)),
                            _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                            _createElement('option', {
                                'className': 'cm_option_title cm_option-unpopular',
                                'disabled': true,
                                'key': '11024'
                            }, _translate(`ymm_bar_unpopular`))
                        ] : null,
                        _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                    ];
                }
                function scopeShowSelectedValues4() {
                    var showSelectedValues = this.selectedEntries.length;
                    return _createElement('option', {
                        'key': '_current',
                        'value': '_current'
                    }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                        _translate(`select_title`),
                        ' ',
                        this.title
                    ] : null);
                }
                function repeatEntry5(entry, index) {
                    return _createElement('div', {
                        'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                        'key': entry.value,
                        'onClick': () => this.onChange(entry.term)
                    }, this.showCheckboxes ? _createElement('input', {
                        'type': 'checkbox',
                        'readOnly': true,
                        'checked': entry.selected,
                        'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                        'key': '3324'
                    }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                        'className': 'cm_dropdown_hitCount',
                        'key': '3526'
                    }, entry.hitCount) : null);
                }
                return _createElement('div', { 'className': this.extraClassName }, !this.isSearchable ? _createElement('div', {
                    'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                    'key': '39'
                }, _createElement('select', {
                    'className': 'cm_select_inner-select cm_select__pretty',
                    'onChange': this.onChange,
                    'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                    'disabled': this.disabled,
                    'aria-label': this.title
                }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                            return _createElement('div', { 'className': 'cm_filterInput' });
                        }, {
                            widgetName: 'undefined',
                            items: undefined
                        })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                    'div',
                    {
                        'className': 'cm_dropdown cm_select_dropdown cm_hide',
                        'aria-label': this.title,
                        'key': '2586'
                    },
                    !this.hideNullOption ? _createElement('div', {
                        'className': 'option',
                        'key': 'null-option',
                        'onClick': () => this.onChange('')
                    }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                    this.loading ? _createElement('div', {
                        'className': 'option',
                        'key': 'null-option',
                        'disabled': true
                    }, _translate(`select_loading`)) : null,
                    !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                ]) : null);
            }, { count: undefined })];
    }
    function scopeIsPLPProduct3() {
        var isPLP = !this.productData;
        var product = this.productData ?? this;
        return [product.is_autosync_allowed ? _createElement('button', {
                'onClick': () => window.Convermax.openAutoSyncDialog(product.autosync_id, product.autosync_mpn, product.FitmentType?.includes('Tire')),
                'className': !isPLP ? 'cm_view-on-vehicle-btn' : 'cm-product-card__vehicle',
                'type': 'button',
                'key': '200301'
            }, [_createElement('svg', {
                    'className': 'cm_icon-vehicle',
                    'xmlns': 'http://www.w3.org/2000/svg',
                    'width': '16',
                    'height': '14',
                    'viewBox': '0 0 16 14',
                    'fill': 'none',
                    'key': '204260'
                }, _createElement('path', {
                    'd': 'M4.60249 3.10189L3.86843 5.20001H12.1315L11.3975 3.10189C11.2709 2.74189 10.9306 2.50001 10.5481 2.50001H5.45186C5.06936 2.50001 4.72905 2.74189 4.60249 3.10189ZM1.91374 5.33501L2.90374 2.50845C3.28343 1.42564 4.30436 0.700012 5.45186 0.700012H10.5481C11.6956 0.700012 12.7165 1.42564 13.0962 2.50845L14.0862 5.33501C14.7387 5.60501 15.2 6.24907 15.2 7.00001V12.4C15.2 12.8978 14.7978 13.3 14.3 13.3H13.4C12.9022 13.3 12.5 12.8978 12.5 12.4V11.5H3.49999V12.4C3.49999 12.8978 3.0978 13.3 2.59999 13.3H1.69999C1.20218 13.3 0.799988 12.8978 0.799988 12.4V7.00001C0.799988 6.24907 1.26124 5.60501 1.91374 5.33501ZM4.39999 8.35001C4.39999 7.8522 3.9978 7.45001 3.49999 7.45001C3.00218 7.45001 2.59999 7.8522 2.59999 8.35001C2.59999 8.84782 3.00218 9.25001 3.49999 9.25001C3.9978 9.25001 4.39999 8.84782 4.39999 8.35001ZM12.5 9.25001C12.9978 9.25001 13.4 8.84782 13.4 8.35001C13.4 7.8522 12.9978 7.45001 12.5 7.45001C12.0022 7.45001 11.6 7.8522 11.6 8.35001C11.6 8.84782 12.0022 9.25001 12.5 9.25001Z',
                    'fill': '#1758BF'
                }))], '\n    ', _translate(`view_product_on_vehicle`), '\n  ') : null];
    }
    function repeatSelects4(selects, selectsIndex) {
        return [selects(function () {
                function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                }
                function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                }
                function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                    var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                    var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                    var isPopularField = popularEntries.length && unpopularEntries.length;
                    return [
                        !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                            'value': '',
                            'key': 'null-option'
                        }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                        this.loading ? _createElement('option', {
                            'key': 'loading-option',
                            'disabled': true
                        }, _translate(`select_loading`)) : null,
                        isPopularField ? [
                            _createElement('option', {
                                'className': 'cm_option_title cm_option-popular',
                                'disabled': true,
                                'key': '11021'
                            }, _translate(`ymm_bar_popular`)),
                            _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                            _createElement('option', {
                                'className': 'cm_option_title cm_option-unpopular',
                                'disabled': true,
                                'key': '11024'
                            }, _translate(`ymm_bar_unpopular`))
                        ] : null,
                        _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                    ];
                }
                function scopeShowSelectedValues4() {
                    var showSelectedValues = this.selectedEntries.length;
                    return _createElement('option', {
                        'key': '_current',
                        'value': '_current'
                    }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                        _translate(`select_title`),
                        ' ',
                        this.title
                    ] : null);
                }
                function repeatEntry5(entry, index) {
                    return _createElement('div', {
                        'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                        'key': entry.value,
                        'onClick': () => this.onChange(entry.term)
                    }, this.showCheckboxes ? _createElement('input', {
                        'type': 'checkbox',
                        'readOnly': true,
                        'checked': entry.selected,
                        'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                        'key': '3324'
                    }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                        'className': 'cm_dropdown_hitCount',
                        'key': '3526'
                    }, entry.hitCount) : null);
                }
                return _createElement('div', { 'className': this.extraClassName }, !this.isSearchable ? _createElement('div', {
                    'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                    'key': '39'
                }, _createElement('select', {
                    'className': 'cm_select_inner-select cm_select__pretty',
                    'onChange': this.onChange,
                    'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                    'disabled': this.disabled,
                    'aria-label': this.title
                }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                            return _createElement('div', { 'className': 'cm_filterInput' });
                        }, {
                            widgetName: 'undefined',
                            items: undefined
                        })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                    'div',
                    {
                        'className': 'cm_dropdown cm_select_dropdown cm_hide',
                        'aria-label': this.title,
                        'key': '2586'
                    },
                    !this.hideNullOption ? _createElement('div', {
                        'className': 'option',
                        'key': 'null-option',
                        'onClick': () => this.onChange('')
                    }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                    this.loading ? _createElement('div', {
                        'className': 'option',
                        'key': 'null-option',
                        'disabled': true
                    }, _translate(`select_loading`)) : null,
                    !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                ]) : null);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__verify-fitment cm_vehicle-widget__collapsible' }, this.template === 'active' ? _createElement('div', {
        'className': 'cm_vehicle-widget_dropdowns cmTemplate_active',
        'key': '99'
    }, !this.withCollapsing ? [
        _createElement('div', {
            'className': 'cm_vehicle-widget_title',
            'key': '2081'
        }, window.Convermax.config?.verifyFitmentTitle || _translate(`verify_fitment_title`)),
        _createElement('div', {
            'className': 'cm_vehicle-widget_body',
            'key': '2083'
        }, _createElement.apply(this, [
            'div',
            { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
            _map(this.selects, repeatSelects1.bind(this))
        ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
            'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go button cm_button__primary',
            'onClick': this.selectVehicle,
            'disabled': !this.allowToSetVehicle,
            'role': 'button',
            'tabIndex': this.allowToSetVehicle ? '0' : '-1'
        }, '\n    ', _translate(`ymm_bar_submit`), '\n  '), _createElement('div', {
            'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear button cm_button__secondary',
            'onClick': this.discardVehicle,
            'disabled': !this.allowToDiscardVehicle,
            'role': 'button',
            'tabIndex': this.allowToDiscardVehicle ? '0' : '-1'
        }, '\n    ', _translate(`ymm_bar_clear`), '\n  ')))
    ] : null, this.withCollapsing ? [
        _createElement('div', {
            'className': 'cm_vehicle-widget_header cm_vehicle-widget__verify-fitment_header',
            'onClick': this.toggleCollapsed,
            'key': '68581'
        }, [_createElement('svg', {
                'className': 'cm_icon',
                'width': '28',
                'height': '27',
                'viewBox': '0 0 28 27',
                'fill': 'none',
                'xmlns': 'http://www.w3.org/2000/svg',
                'key': '70260'
            }, _createElement('path', {
                'd': 'M14 26.4444C21.7328 26.4444 28 20.5254 28 13.2222C28 5.91901 21.7328 0 14 0C6.26719 0 0 5.91901 0 13.2222C0 20.5254 6.26719 26.4444 14 26.4444ZM14 9.09028C13.032 9.09028 12.25 9.82886 12.25 10.7431C12.25 11.43 11.6648 11.9826 10.9375 11.9826C10.2102 11.9826 9.625 11.43 9.625 10.7431C9.625 8.46016 11.5828 6.61111 14 6.61111C16.4172 6.61111 18.375 8.46016 18.375 10.7431C18.375 13.1809 16.4062 14.2139 15.3125 14.5909V14.7872C15.3125 15.4741 14.7273 16.0268 14 16.0268C13.2727 16.0268 12.6875 15.4741 12.6875 14.7872V14.3688C12.6875 13.31 13.4969 12.5508 14.3336 12.2925C14.6836 12.1841 15.0555 12.0085 15.3289 11.7605C15.5641 11.5436 15.75 11.2441 15.75 10.7482C15.75 9.83403 14.968 9.09544 14 9.09544V9.09028ZM12.25 19.0069C12.25 18.0928 13.032 17.3542 14 17.3542C14.968 17.3542 15.75 18.0928 15.75 19.0069C15.75 19.9211 14.968 20.6597 14 20.6597C13.032 20.6597 12.25 19.9211 12.25 19.0069Z',
                'fill': '#1758BF'
            }))], _createElement('div', { 'className': 'cm_vehicle-widget_header-content' }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, window.Convermax.config?.verifyFitmentTitle || _translate(`verify_fitment_title`)), _createElement('div', { 'className': 'cm_vehicle-widget_subtitle' }, 'Select your vehicle below')), !this.collapsed ? [_createElement('svg', {
                'className': 'cm_icon cm_icon-angle up',
                'height': '20px',
                'role': 'img',
                'viewBox': '39 30 565 565',
                'aria-hidden': 'true',
                'key': '83910'
            }, _createElement('path', { 'd': 'M600,189q0-7-6-12l-28-28q-5-6-12-6t-13,6l-220,219-219-219q-5-6-13-6t-12,6l-28,28q-6,5-6,12t6,13l260,260q5,6,12,6t13-6l260-260q6-5,6-13z' }))] : null, this.collapsed ? [_createElement('svg', {
                'className': 'cm_icon cm_icon-angle down',
                'height': '20px',
                'role': 'img',
                'viewBox': '39 30 565 565',
                'aria-hidden': 'true',
                'key': '87130'
            }, _createElement('path', { 'd': 'M600,189q0-7-6-12l-28-28q-5-6-12-6t-13,6l-220,219-219-219q-5-6-13-6t-12,6l-28,28q-6,5-6,12t6,13l260,260q5,6,12,6t13-6l260-260q6-5,6-13z' }))] : null),
        _createElement('div', {
            'className': 'cm_vehicle-widget_body cm_collapsible-elem',
            'key': '68583'
        }, _createElement.apply(this, [
            'div',
            { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
            _map(this.selects, repeatSelects2.bind(this))
        ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
            'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go button cm_button__primary',
            'onClick': this.selectVehicle,
            'disabled': !this.allowToSetVehicle,
            'role': 'button',
            'tabIndex': this.allowToSetVehicle ? '0' : '-1'
        }, '\n    ', _translate(`ymm_bar_submit`), '\n  '), _createElement('div', {
            'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear button cm_button__secondary',
            'onClick': this.discardVehicle,
            'disabled': !this.allowToDiscardVehicle,
            'role': 'button',
            'tabIndex': this.allowToDiscardVehicle ? '0' : '-1'
        }, '\n    ', _translate(`ymm_bar_clear`), '\n  ')))
    ] : null) : null, this.template === 'locked' ? _createElement('div', {
        'className': 'cm_vehicle-widget_label cm_verify-fitment cm_verify-fitment__' + this.fits + ' cmTemplate_locked',
        'key': '15542'
    }, _createElement('div', { 'className': 'cm_verify-fitment_fitment__container' }, _createElement('div', { 'className': 'cm_verify-fitment_icon' }, this.fits === 'yes' || this.fits === 'universal' ? [_createElement('svg', {
            'className': 'cm_icon',
            'width': '28',
            'height': '28',
            'viewBox': '0 0 28 28',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '157940'
        }, _createElement('path', {
            'd': 'M14 28C6.26719 28 0 21.7328 0 14C0 6.26719 6.26719 0 14 0C21.7328 0 28 6.26719 28 14C28 21.7328 21.7328 28 14 28ZM20.4531 7.96797C19.868 7.54141 19.0477 7.67266 18.6211 8.25781L12.0914 17.2375L9.24219 14.3883C8.72812 13.8742 7.89687 13.8742 7.38828 14.3883C6.87969 14.9023 6.87422 15.7336 7.38828 16.2422L11.3258 20.1797C11.5992 20.4531 11.9711 20.5898 12.3539 20.5625C12.7367 20.5352 13.0867 20.3383 13.3109 20.0266L20.743 9.8C21.1695 9.21484 21.0383 8.39453 20.4531 7.96797Z',
            'fill': '#3F7D32'
        }))] : null, this.fits === 'no' ? [_createElement('svg', {
            'className': 'cm_icon',
            'width': '28',
            'height': '27',
            'viewBox': '0 0 28 27',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '165260'
        }, _createElement('path', {
            'd': 'M20.0813 21.3053L5.44141 7.47882C4.21641 9.10061 3.5 11.0839 3.5 13.2222C3.5 18.6971 8.20312 23.1389 14 23.1389C16.2695 23.1389 18.3695 22.4623 20.0813 21.3053ZM22.5586 18.9656C23.7836 17.3438 24.5 15.3605 24.5 13.2222C24.5 7.7474 19.7969 3.30556 14 3.30556C11.7305 3.30556 9.63047 3.98216 7.91875 5.13911L22.5586 18.9656ZM0 13.2222C0 5.91901 6.26719 0 14 0C21.7328 0 28 5.91901 28 13.2222C28 20.5254 21.7328 26.4444 14 26.4444C6.26719 26.4444 0 20.5254 0 13.2222Z',
            'fill': '#D3162D'
        }))] : null, this.fits === 'unknown' ? [_createElement('svg', {
            'className': 'cm_icon',
            'width': '28',
            'height': '27',
            'viewBox': '0 0 28 27',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '172060'
        }, _createElement('path', {
            'd': 'M14 26.4444C21.7328 26.4444 28 20.5254 28 13.2222C28 5.91901 21.7328 0 14 0C6.26719 0 0 5.91901 0 13.2222C0 20.5254 6.26719 26.4444 14 26.4444ZM14 9.09028C13.032 9.09028 12.25 9.82886 12.25 10.7431C12.25 11.43 11.6648 11.9826 10.9375 11.9826C10.2102 11.9826 9.625 11.43 9.625 10.7431C9.625 8.46016 11.5828 6.61111 14 6.61111C16.4172 6.61111 18.375 8.46016 18.375 10.7431C18.375 13.1809 16.4062 14.2139 15.3125 14.5909V14.7872C15.3125 15.4741 14.7273 16.0268 14 16.0268C13.2727 16.0268 12.6875 15.4741 12.6875 14.7872V14.3688C12.6875 13.31 13.4969 12.5508 14.3336 12.2925C14.6836 12.1841 15.0555 12.0085 15.3289 11.7605C15.5641 11.5436 15.75 11.2441 15.75 10.7482C15.75 9.83403 14.968 9.09544 14 9.09544V9.09028ZM12.25 19.0069C12.25 18.0928 13.032 17.3542 14 17.3542C14.968 17.3542 15.75 18.0928 15.75 19.0069C15.75 19.9211 14.968 20.6597 14 20.6597C13.032 20.6597 12.25 19.9211 12.25 19.0069Z',
            'fill': '#1758BF'
        }))] : null, this.fits === 'aggressive' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-exclamation',
            'height': '20',
            'viewBox': '0 0 256 255',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '183190'
        }, _createElement('path', {
            'fillRule': 'evenodd',
            'clipRule': 'evenodd',
            'd': 'M112.098 0.528293C105.702 1.30529 89.9175 5.21029 83.6615 7.56329C64.7805 14.6653 49.2545 25.1013 34.5985 40.5423C-0.248547 77.2563 -9.69655 131.035 10.4785 177.833C17.3025 193.66 23.8655 203.124 37.5985 216.939C51.1805 230.602 61.9924 238.186 77.0984 244.649C104.915 256.549 138.414 258.074 166.974 248.741C177.998 245.139 194.9 236.465 203.598 229.946C212.511 223.266 228.177 206.84 233.748 198.332C262.341 154.67 262.457 100.262 234.048 56.8423C227.749 47.2143 210.42 29.3733 201.129 22.9513C185.936 12.4473 166.593 4.56829 148.217 1.39729C140.191 0.0112929 120.292 -0.466707 112.098 0.528293ZM146.598 101.364V157.864H127.598H108.598V101.364V44.8643H127.598H146.598V101.364ZM136.699 179.648C141.014 181.902 142.56 183.448 144.814 187.763C148.264 194.367 148.343 198.988 145.115 205.418C138.666 218.265 122.327 220.292 112.789 209.428C104.371 199.842 107.303 185.18 118.78 179.461C125.482 176.121 130.038 176.169 136.699 179.648Z'
        }))] : null), _createElement('div', { 'className': 'cm_verify-fitment_fitment' }, _createElement('div', { 'className': 'cm_verify-fitment_title' }, this.fits === 'yes' ? [_translate(`verify_fitment_fits`)] : null, this.fits === 'no' ? [_translate(`verify_fitment_does_not_fit`)] : null, this.fits === 'aggressive' ? [_translate(`verify_fitment_aggressive_fits`)] : null), this.fits === 'yes' ? [scopeIsPLPProduct3.apply(this, [])] : null, this.fits === 'no' ? _createElement('a', {
        'href': window.Convermax.getCategoryVehicleUrl(),
        'className': 'cm_verify-fitment_compatible-parts',
        'key': '21697'
    }, '\n          ', _translate(`verify_fitment_compatible_parts`), '\n          ', [_createElement('svg', {
            'className': 'cm_icon cm_icon-arrow right',
            'height': '20px',
            'role': 'img',
            'viewBox': '0 0 512 512',
            'aria-hidden': 'true',
            'key': '219000'
        }, _createElement('path', { 'd': 'M189.3,128.4L89,233.4c-6,5.8-9,13.7-9,22.4c0,8.7,3,16.5,9,22.4l100.3,105.4c11.9,12.5,31.3,12.5,43.2,0c11.9-12.5,11.9-32.7,0-45.2L184.4,288h217c16.9,0,30.6-14.3,30.6-32c0-17.7-13.7-32-30.6-32h-217l48.2-50.4c11.9-12.5,11.9-32.7,0-45.2C220.6,115.9,201.3,115.9,189.3,128.4z' }))]) : null), _createElement('a', {
        'className': 'cm_verify-fitment_change',
        'onClick': this.changeVehicle
    }, _translate(`ymm_bar_change`)))) : null, this.template === 'inexact' ? _createElement('div', {
        'className': 'cm_vehicle-widget_specifier cmTemplate_inexact',
        'key': '22483'
    }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, '\n      ', _translate(`verify_fitment_specify`, { 
        fieldsToSpecify: this.
        fieldsToSpecify, 
        vehicleString
    : this.
        vehicleString
     }), '\n    '), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
        'div',
        { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
        _map(this.selects, repeatSelects4.bind(this))
    ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
        'className': 'cm_vehicle-widget_button button button--primary button cm_button__primary',
        'onClick': this.selectVehicle,
        'disabled': !this.allowToSetVehicle,
        'role': 'button',
        'tabIndex': this.allowToSetVehicle ? '0' : '-1'
    }, '\n    ', _translate(`ymm_bar_submit`), '\n  ')))) : null, this.template === 'universal' ? _createElement('div', {
        'className': 'cm_vehicle-widget_label cm_verify-fitment cm_verify-fitment__universal cmTemplate_universal',
        'key': '28874'
    }, _createElement('div', { 'className': 'cm_verify-fitment_icon' }, this.fits === 'yes' || this.fits === 'universal' ? [_createElement('svg', {
            'className': 'cm_icon',
            'width': '28',
            'height': '28',
            'viewBox': '0 0 28 28',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '290730'
        }, _createElement('path', {
            'd': 'M14 28C6.26719 28 0 21.7328 0 14C0 6.26719 6.26719 0 14 0C21.7328 0 28 6.26719 28 14C28 21.7328 21.7328 28 14 28ZM20.4531 7.96797C19.868 7.54141 19.0477 7.67266 18.6211 8.25781L12.0914 17.2375L9.24219 14.3883C8.72812 13.8742 7.89687 13.8742 7.38828 14.3883C6.87969 14.9023 6.87422 15.7336 7.38828 16.2422L11.3258 20.1797C11.5992 20.4531 11.9711 20.5898 12.3539 20.5625C12.7367 20.5352 13.0867 20.3383 13.3109 20.0266L20.743 9.8C21.1695 9.21484 21.0383 8.39453 20.4531 7.96797Z',
            'fill': '#3F7D32'
        }))] : null, this.fits === 'no' ? [_createElement('svg', {
            'className': 'cm_icon',
            'width': '28',
            'height': '27',
            'viewBox': '0 0 28 27',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '298050'
        }, _createElement('path', {
            'd': 'M20.0813 21.3053L5.44141 7.47882C4.21641 9.10061 3.5 11.0839 3.5 13.2222C3.5 18.6971 8.20312 23.1389 14 23.1389C16.2695 23.1389 18.3695 22.4623 20.0813 21.3053ZM22.5586 18.9656C23.7836 17.3438 24.5 15.3605 24.5 13.2222C24.5 7.7474 19.7969 3.30556 14 3.30556C11.7305 3.30556 9.63047 3.98216 7.91875 5.13911L22.5586 18.9656ZM0 13.2222C0 5.91901 6.26719 0 14 0C21.7328 0 28 5.91901 28 13.2222C28 20.5254 21.7328 26.4444 14 26.4444C6.26719 26.4444 0 20.5254 0 13.2222Z',
            'fill': '#D3162D'
        }))] : null, this.fits === 'unknown' ? [_createElement('svg', {
            'className': 'cm_icon',
            'width': '28',
            'height': '27',
            'viewBox': '0 0 28 27',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '304850'
        }, _createElement('path', {
            'd': 'M14 26.4444C21.7328 26.4444 28 20.5254 28 13.2222C28 5.91901 21.7328 0 14 0C6.26719 0 0 5.91901 0 13.2222C0 20.5254 6.26719 26.4444 14 26.4444ZM14 9.09028C13.032 9.09028 12.25 9.82886 12.25 10.7431C12.25 11.43 11.6648 11.9826 10.9375 11.9826C10.2102 11.9826 9.625 11.43 9.625 10.7431C9.625 8.46016 11.5828 6.61111 14 6.61111C16.4172 6.61111 18.375 8.46016 18.375 10.7431C18.375 13.1809 16.4062 14.2139 15.3125 14.5909V14.7872C15.3125 15.4741 14.7273 16.0268 14 16.0268C13.2727 16.0268 12.6875 15.4741 12.6875 14.7872V14.3688C12.6875 13.31 13.4969 12.5508 14.3336 12.2925C14.6836 12.1841 15.0555 12.0085 15.3289 11.7605C15.5641 11.5436 15.75 11.2441 15.75 10.7482C15.75 9.83403 14.968 9.09544 14 9.09544V9.09028ZM12.25 19.0069C12.25 18.0928 13.032 17.3542 14 17.3542C14.968 17.3542 15.75 18.0928 15.75 19.0069C15.75 19.9211 14.968 20.6597 14 20.6597C13.032 20.6597 12.25 19.9211 12.25 19.0069Z',
            'fill': '#1758BF'
        }))] : null, this.fits === 'aggressive' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-exclamation',
            'height': '20',
            'viewBox': '0 0 256 255',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '315980'
        }, _createElement('path', {
            'fillRule': 'evenodd',
            'clipRule': 'evenodd',
            'd': 'M112.098 0.528293C105.702 1.30529 89.9175 5.21029 83.6615 7.56329C64.7805 14.6653 49.2545 25.1013 34.5985 40.5423C-0.248547 77.2563 -9.69655 131.035 10.4785 177.833C17.3025 193.66 23.8655 203.124 37.5985 216.939C51.1805 230.602 61.9924 238.186 77.0984 244.649C104.915 256.549 138.414 258.074 166.974 248.741C177.998 245.139 194.9 236.465 203.598 229.946C212.511 223.266 228.177 206.84 233.748 198.332C262.341 154.67 262.457 100.262 234.048 56.8423C227.749 47.2143 210.42 29.3733 201.129 22.9513C185.936 12.4473 166.593 4.56829 148.217 1.39729C140.191 0.0112929 120.292 -0.466707 112.098 0.528293ZM146.598 101.364V157.864H127.598H108.598V101.364V44.8643H127.598H146.598V101.364ZM136.699 179.648C141.014 181.902 142.56 183.448 144.814 187.763C148.264 194.367 148.343 198.988 145.115 205.418C138.666 218.265 122.327 220.292 112.789 209.428C104.371 199.842 107.303 185.18 118.78 179.461C125.482 176.121 130.038 176.169 136.699 179.648Z'
        }))] : null), _createElement('div', { 'className': 'cm_verify-fitment_fitment' }, _createElement('div', { 'className': 'cm_verify-fitment_title' }, window.Convermax.config?.verifyFitmentUniversalTitle || window.Convermax.config?.fitmentUniversalTitle || _translate(`fitment_universal_title`)), _createElement('div', { 'className': 'cm_verify-fitment_notes' }, window.Convermax.config?.verifyFitmentUniversalText || window.Convermax.config?.fitmentUniversalText || _translate(`fitment_universal_text`)))) : null, this.template === 'unknown' ? _createElement('div', {
        'className': 'cm_vehicle-widget_label cm_verify-fitment cm_verify-fitment__unknown cmTemplate_unknown',
        'key': '33245'
    }, _createElement('div', { 'className': 'cm_verify-fitment_icon' }, this.fits === 'yes' || this.fits === 'universal' ? [_createElement('svg', {
            'className': 'cm_icon',
            'width': '28',
            'height': '28',
            'viewBox': '0 0 28 28',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '334380'
        }, _createElement('path', {
            'd': 'M14 28C6.26719 28 0 21.7328 0 14C0 6.26719 6.26719 0 14 0C21.7328 0 28 6.26719 28 14C28 21.7328 21.7328 28 14 28ZM20.4531 7.96797C19.868 7.54141 19.0477 7.67266 18.6211 8.25781L12.0914 17.2375L9.24219 14.3883C8.72812 13.8742 7.89687 13.8742 7.38828 14.3883C6.87969 14.9023 6.87422 15.7336 7.38828 16.2422L11.3258 20.1797C11.5992 20.4531 11.9711 20.5898 12.3539 20.5625C12.7367 20.5352 13.0867 20.3383 13.3109 20.0266L20.743 9.8C21.1695 9.21484 21.0383 8.39453 20.4531 7.96797Z',
            'fill': '#3F7D32'
        }))] : null, this.fits === 'no' ? [_createElement('svg', {
            'className': 'cm_icon',
            'width': '28',
            'height': '27',
            'viewBox': '0 0 28 27',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '341700'
        }, _createElement('path', {
            'd': 'M20.0813 21.3053L5.44141 7.47882C4.21641 9.10061 3.5 11.0839 3.5 13.2222C3.5 18.6971 8.20312 23.1389 14 23.1389C16.2695 23.1389 18.3695 22.4623 20.0813 21.3053ZM22.5586 18.9656C23.7836 17.3438 24.5 15.3605 24.5 13.2222C24.5 7.7474 19.7969 3.30556 14 3.30556C11.7305 3.30556 9.63047 3.98216 7.91875 5.13911L22.5586 18.9656ZM0 13.2222C0 5.91901 6.26719 0 14 0C21.7328 0 28 5.91901 28 13.2222C28 20.5254 21.7328 26.4444 14 26.4444C6.26719 26.4444 0 20.5254 0 13.2222Z',
            'fill': '#D3162D'
        }))] : null, this.fits === 'unknown' ? [_createElement('svg', {
            'className': 'cm_icon',
            'width': '28',
            'height': '27',
            'viewBox': '0 0 28 27',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '348500'
        }, _createElement('path', {
            'd': 'M14 26.4444C21.7328 26.4444 28 20.5254 28 13.2222C28 5.91901 21.7328 0 14 0C6.26719 0 0 5.91901 0 13.2222C0 20.5254 6.26719 26.4444 14 26.4444ZM14 9.09028C13.032 9.09028 12.25 9.82886 12.25 10.7431C12.25 11.43 11.6648 11.9826 10.9375 11.9826C10.2102 11.9826 9.625 11.43 9.625 10.7431C9.625 8.46016 11.5828 6.61111 14 6.61111C16.4172 6.61111 18.375 8.46016 18.375 10.7431C18.375 13.1809 16.4062 14.2139 15.3125 14.5909V14.7872C15.3125 15.4741 14.7273 16.0268 14 16.0268C13.2727 16.0268 12.6875 15.4741 12.6875 14.7872V14.3688C12.6875 13.31 13.4969 12.5508 14.3336 12.2925C14.6836 12.1841 15.0555 12.0085 15.3289 11.7605C15.5641 11.5436 15.75 11.2441 15.75 10.7482C15.75 9.83403 14.968 9.09544 14 9.09544V9.09028ZM12.25 19.0069C12.25 18.0928 13.032 17.3542 14 17.3542C14.968 17.3542 15.75 18.0928 15.75 19.0069C15.75 19.9211 14.968 20.6597 14 20.6597C13.032 20.6597 12.25 19.9211 12.25 19.0069Z',
            'fill': '#1758BF'
        }))] : null, this.fits === 'aggressive' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-exclamation',
            'height': '20',
            'viewBox': '0 0 256 255',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '359630'
        }, _createElement('path', {
            'fillRule': 'evenodd',
            'clipRule': 'evenodd',
            'd': 'M112.098 0.528293C105.702 1.30529 89.9175 5.21029 83.6615 7.56329C64.7805 14.6653 49.2545 25.1013 34.5985 40.5423C-0.248547 77.2563 -9.69655 131.035 10.4785 177.833C17.3025 193.66 23.8655 203.124 37.5985 216.939C51.1805 230.602 61.9924 238.186 77.0984 244.649C104.915 256.549 138.414 258.074 166.974 248.741C177.998 245.139 194.9 236.465 203.598 229.946C212.511 223.266 228.177 206.84 233.748 198.332C262.341 154.67 262.457 100.262 234.048 56.8423C227.749 47.2143 210.42 29.3733 201.129 22.9513C185.936 12.4473 166.593 4.56829 148.217 1.39729C140.191 0.0112929 120.292 -0.466707 112.098 0.528293ZM146.598 101.364V157.864H127.598H108.598V101.364V44.8643H127.598H146.598V101.364ZM136.699 179.648C141.014 181.902 142.56 183.448 144.814 187.763C148.264 194.367 148.343 198.988 145.115 205.418C138.666 218.265 122.327 220.292 112.789 209.428C104.371 199.842 107.303 185.18 118.78 179.461C125.482 176.121 130.038 176.169 136.699 179.648Z'
        }))] : null), _createElement('div', { 'className': 'cm_verify-fitment_fitment' }, _createElement('div', { 'className': 'cm_verify-fitment_title' }, window.Convermax.config?.fitmentUnknownTitle || _translate(`fitment_unknown_title`)), _createElement('div', { 'className': 'cm_verify-fitment_notes' }, window.Convermax.config?.fitmentUnknownText || _translate(`fitment_unknown_text`)))) : null);
}
        export const componentNames = ["cm:filterInput","cm:filterInput","cm:filterInput"]